import moment from "moment";

export const displayDate = (
  d: string,
  mode: "full" | "diff" = "full"
): string => {
  moment.locale("de");
  const date = moment(d);
  return (
    `${date.fromNow()}` +
    (mode === "full" ? ` (${date.format("D. MMMM YYYY [um] H:mm:ss")})` : "")
  );
};
